<template>
  <div id="app">
    <div class="copyright">
      <div class="rotatebox">
        <div v-for="item in 180" :key="item" class="water">
          <div>{{ title }}</div>
          <div>{{ date }}</div>
        </div>
      </div>
    </div>
    <router-view />
    <div v-if="is_debug" class="debug">
      当前非生产环境：{{ site }}
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/utils/index'
import store from '@/store/index'
console.log(location.port)
export default {
  components: {
  },
  data() {
    return {
      title: '',
      is_debug: process.env.NODE_ENV == 'development' && location.host != 'agent.eingdong.com' && (store.state.app.site != 'https://agent.eingdong.com'),
      date: '',
      site: store.state.app.site
    }
  },
  mounted() {
    this.date = parseTime(new Date(), '{y}-{m}-{d}')
    this.title = localStorage.getItem('_yixiang_agent_name') || ''
  }
}
</script>
<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.debug {
  position: fixed;
  left: 50%;
  top: 0;
  z-index: 10000;
  background: #ff3b3b;
  width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding: 0 20px;
  margin-left: -150px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  height: 30px;
  border-radius: 0 0 10px 10px;
}
.copyright {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000000;
  pointer-events: none;
  // background: rgba(222, 0, 0, 0.2);
  // z-index: 99;
  .rotatebox {
    transform: rotate(-45deg);
    transform-origin: top;
    margin-left: -80%;
  }
  .water {
    opacity: 0.05;
    font-size: 15px;
    padding: 80px;
    display: inline-flex;
    flex-direction: column;
    text-align: left;
    & :first-child {
      font-size: 20px;
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
</style>
